import { DecimalPipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Time } from 'models/Time';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'time-picker',
	templateUrl: './time-picker.component.html',
	styleUrls: ['./time-picker.component.scss'],
	imports: [NgClass, DecimalPipe, TranslatePipe]
})

export class TimePickerComponent {
	@Input()
	set model(time: Time | undefined) {
		if (time && time.hour !== undefined && time.minute !== undefined) {
			this.hourSelected = time.hour;

			let minutes = time.minute;
			let delta = 60;
			// Finds the accepted minute choice closest to the requested number
			for (let acceptedMinutes of this.minuteSelector) {
				if (Math.abs(acceptedMinutes - minutes) < delta) {
					delta = Math.abs(acceptedMinutes - minutes);
					this.minuteSelected = acceptedMinutes;
				}
			}
			this.selectedTime = new Time();
			this.selectedTime.hour = this.hourSelected;
			this.selectedTime.minute = this.minuteSelected;
		}
	}
	get model() {
		return this.selectedTime;
	}
	@Output() modelChange = new EventEmitter<Time>();
	@Input() optional = true;
	@Input() set range([startTime, endTime]: number[]) {
		this._startTime = startTime;
		this._endTime = endTime;
		this.updateHourSelector();
	};

	private _startTime = 6;
	private _endTime = 18;

	minuteSelector: number[] = [0, 15, 30, 45];
	hourSelector: number[] = [];
	hourSelected?: number;
	minuteSelected?: number;
	selectedTime?: Time;

	constructor() {
		this.updateHourSelector();
	}

	private updateHourSelector() {
		this.hourSelector = Array((this._endTime - this._startTime)).fill(1).map((x, i) => this._startTime + i);
	}

	selectHour(hour: number) {
		this.hourSelected = hour;
		if (!this.minuteSelected) this.minuteSelected = 0; 
		this.updateSelectedTime();
	}
	selectMinute(minute: number) {
		this.minuteSelected = minute;
		this.updateSelectedTime();
	}
	unsetHourAndMinute() {
		this.hourSelected = undefined;
		this.minuteSelected = undefined;
		this.updateSelectedTime();
	}

	updateSelectedTime() {
		if (this.hourSelected !== undefined && this.minuteSelected !== undefined) {
			this.selectedTime = new Time();
			this.selectedTime.hour = this.hourSelected;
			this.selectedTime.minute = this.minuteSelected;
		} else {
			this.selectedTime = new Time();
		}
		this.modelChange.emit(this.selectedTime);
	}
}
